<script setup>
import MaterialIcon from './MaterialIcon.vue';

defineProps({
  channel: { type: Object, required: true },
  sizeClass: { type: String, default: 'size-5' },
});
</script>

<template>
  <img
    v-if="channel.icon"
    :src="channel.icon"
    :alt="channel.name || channel.id"
    :class="[sizeClass, 'object-contain']"
  />
  <MaterialIcon
    v-else-if="channel.materialIcon"
    :name="channel.materialIcon"
    :class="sizeClass"
  />
</template>
